<template>
  <div class="navBar">
    <router-link tag='div' class="logoBox" to="/">
      <img src="@/assets/img/logo.png" class="logo">
      <span>聚客电影</span>
    </router-link>
    <div class="curCity">
      <div>
        <span class="curCityVal">{{ $store.state.selCityInfo.region_name }}</span>
        <img src="@/assets/img/down.jpg" class="hoverIcon">
      </div>
      <div class="cityList">
        <div>
          <div class="title">
            选择城市
          </div>
          <ul class="scrollCityList">
            <li class="firPItem" v-for="firPItem in cityList">
              <div class="firP">{{ firPItem.firP }}</div>
              <span
                :class="['cityItem', { 'active': $store.state.selCityInfo.region_name && $store.state.selCityInfo.region_name.indexOf(cityItem.region_name) >= 0 }]"
                v-for="cityItem in firPItem.list" @click='selCity(cityItem)'>
                {{ cityItem.region_name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="navBarUl">
      <router-link tag='li' to='/'>首页</router-link>
      <router-link tag='li' to='/movie'>影片</router-link>
      <router-link tag='li' to='/cinema'>影院</router-link>
      <!-- <li class="appDownLoad">
        <div>
          <img src="@/assets/img/appIcon.jpg" class="appIcon">
          <span>移动端下载</span>
          <img src="@/assets/img/down.jpg" class="down">
        </div>
        <div class="qrCode">
          <img src="@/assets/img/appQrcode.jpg">
        </div>
      </li> -->
      <li>
        <div class="avatarBox">
          <div>
            <div class="avatar">
              <img src="@/assets/img/log.jpg" v-if='!$store.state.userInfo.token'>
              <img :src="$store.state.userInfo.avatar" v-if='$store.state.userInfo.token'>
            </div>
            <img src="../assets/img/down.jpg" class="down">
          </div>
          <router-link tag="div" class="myInfoBox" to="/logIn" v-if='!$store.state.userInfo.token'>
            <div class="myInfoItem">登录注册</div>
          </router-link>
          <div class="myInfoBox" v-if='$store.state.userInfo.token'>
            <div class="myInfoItem" @click="logOut">
              <span class="name">{{ $store.state.userInfo.nickname }}</span>
              <span class="toggle">[注销]</span>
            </div>
            <router-link to="/modify" tag="div" class="myInfoItem">修改信息</router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  data() {
    return {
      cityList: []
    }
  },
  created: function () {
    var vueXInfo = this.$store.state;
    console.log(vueXInfo);
    if (!vueXInfo.selCityInfo.region_name && !vueXInfo.selCityInfo.city_code) {
      console.log('没有')
      //获取当前定位 && 获取城市列表
      // this.getLocate();
      this.getLocalCity()
    }
    else {
      //获取城市列表
      this.axiosCityList();
    }
  },
  methods: {
    // getLocate: function () {
    //   var that = this;
    //   that.axios.post('/getIp')
    //     .then(function (res) {
    //       console.log(res);
    //       var ip = res.data.split('"cip": "')[1].split('",')[0];
    //       that.axios.get('/getLocation?ip=' + ip + '&key=X7DBZ-D7Q6W-5TCRA-O2QLZ-H2Z23-MMFKJ')
    //         .then(function (res) {
    //           if (res.data.status == 0) {
    //             console.log("获取当前位置", res.data.result);
    //             var result = res.data.result;
    //             // var vuexSelCityInfo = that.$store.state.selCityInfo;
    //             that.$store.commit('updateLocationInfo', {
    //               // city_code: vuexSelCityInfo.city_code
    //               lat: result.location.lat,
    //               lng: result.location.lng,
    //               region_name: result.ad_info.city, //城市名
    //               city_code: result.ad_info.nation_code
    //             })

    //             //获取城市列表
    //             that.axiosCityList();
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error)
    //         })
    //     })

    // },
    getLocalCity() {
      let that = this
      // var data = {
      //   key: 'X7DBZ-D7Q6W-5TCRA-O2QLZ-H2Z23-MMFKJ', //申请的密钥,写死就行
      // }
      var url = '/getLocation' //这个就是地理位置信息的接口
      that.axios.get(url)
        .then((res) => {
          console.log("获取当前位置", res.data.result);
          const result = res.data.result;
          that.$store.commit('updateLocationInfo', {
            lat: result.location.lat,
            lng: result.location.lng,
            region_name: result.ad_info.city, //城市名
            city_code: result.ad_info.nation_code
          })
          //获取城市列表
          that.axiosCityList();
        })
        .catch((error) => {
          console.log(error)
        })
    },
    logOut: function () {
      //清空登录信息
      this.$store.commit('logout')
    },
    axiosCityList: function () {
      var that = this;
      that.axios.post('/resUrlTB/api/v2/getRegions')
        .then(function (res) {
          if (res.data.code == 0) {
            var resList = res.data.content.regions;
            var cityList = [];
            for (var i = 0; i < resList.length; i++) {
              if (!resList[i].region_name) {
                continue;
              }
              //如果找到相同城市
              var vueXInfo = that.$store.state;
              if (vueXInfo.selCityInfo.region_name && vueXInfo.selCityInfo.region_name.indexOf(resList[i].region_name) >= 0) {
                that.$store.commit('updateLocationInfo', {
                  lat: vueXInfo.lat,
                  lng: vueXInfo.lng,
                  region_name: resList[i].region_name, //城市名
                  city_code: resList[i].city_code
                })
              }

              var item_firP = resList[i].pin_yin.substring(0, 1); //首字母拼音val
              var isSameFirP = false; //相同首字母拼音
              for (var c = 0; c < cityList.length; c++) {
                //有相同首字母拼音
                if (item_firP == cityList[c].firP) {
                  cityList[c].list.push({
                    region_name: resList[i].region_name,
                    id: resList[i].id,
                    city_code: resList[i].city_code,
                  })

                  isSameFirP = true;
                  break;
                }
              }
              //没有相同首字母拼音
              if (!isSameFirP) {
                var firPItem = {
                  firP: item_firP,
                  list: []
                }
                firPItem.list.push({
                  region_name: resList[i].region_name,
                  id: resList[i].id,
                  city_code: resList[i].city_code,
                })
                cityList.push(firPItem);
              }
            }
            that.cityList = cityList;
          }
        })
    },
    selCity: function (cityItem) {
      var vueXInfo = this.$store.state;
      this.$store.commit('updateLocationInfo', {
        lat: vueXInfo.lat,
        lng: vueXInfo.lng,
        region_name: cityItem.region_name,
        city_code: cityItem.city_code
      })
      if (this.$route.path == '/') {
        this.$router.go(0)
      } else {
        this.$router.replace('/')
      }
    },
  },
}
</script>

<style scoped src='@/assets/css/navBar.css'></style>
